(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-top"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header.section-header-bottom');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener("DOMContentLoaded", function () {
    const hamburger  = document.getElementById("HamburgerToggle");
    const offCanvas  = document.getElementById("OffCanvasMenu");
    const closeBtn   = document.getElementById("CloseMenu");
    const overlay    = document.getElementById("MenuOverlay");
    const catToggle  = document.getElementById("CategoriesToggle");
    const catDrawer  = document.getElementById("CatDrawer");
    const catBackBtn = document.getElementById("CatDrawerBack");

    if (!hamburger || !offCanvas) {
      console.error("Hamburger or OffCanvas menu not found");
      return;
    }

    /* --- Main drawer --- */
    const openMenu = () => {
      offCanvas.classList.add("open");
      overlay.classList.add("active");
      document.body.style.overflow = "hidden";
      hamburger.setAttribute("aria-expanded", "true");
    };

    const closeMenu = () => {
      closeCatDrawer();
      offCanvas.classList.remove("open");
      overlay.classList.remove("active");
      document.body.style.overflow = "";
      hamburger.setAttribute("aria-expanded", "false");
    };

    hamburger.addEventListener("click", openMenu);
    closeBtn.addEventListener("click", closeMenu);
    overlay.addEventListener("click", closeMenu);

    /* --- Categories sub-drawer --- */
    const openCatDrawer = () => {
      catDrawer.classList.add("open");
      offCanvas.classList.add("pushed");
      catToggle.setAttribute("aria-expanded", "true");
    };

    const closeCatDrawer = () => {
      catDrawer.classList.remove("open");
      offCanvas.classList.remove("pushed");
      if (catToggle) catToggle.setAttribute("aria-expanded", "false");
    };

    if (catToggle) catToggle.addEventListener("click", openCatDrawer);
    if (catBackBtn) catBackBtn.addEventListener("click", closeCatDrawer);

    /* --- Escape key --- */
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        if (catDrawer && catDrawer.classList.contains("open")) {
          closeCatDrawer();
        } else if (offCanvas && offCanvas.classList.contains("open")) {
          closeMenu();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const hamburger  = document.getElementById("HamburgerToggle");
    const offCanvas  = document.getElementById("OffCanvasMenu");
    const closeBtn   = document.getElementById("CloseMenu");
    const overlay    = document.getElementById("MenuOverlay");

    if (!hamburger || !offCanvas) return;

    const openMenu = () => {
      offCanvas.classList.add("open");
      overlay.classList.add("active");
      document.body.style.overflow = "hidden";
      hamburger.setAttribute("aria-expanded", "true");
    };

    const closeAllCatDrawers = () => {
      document.querySelectorAll(".offcanvas-cat-drawer.open").forEach(function (d) {
        d.classList.remove("open");
      });
      offCanvas.classList.remove("pushed");
    };

    const closeMenu = () => {
      closeAllCatDrawers();
      offCanvas.classList.remove("open");
      overlay.classList.remove("active");
      document.body.style.overflow = "";
      hamburger.setAttribute("aria-expanded", "false");
    };

    hamburger.addEventListener("click", openMenu);
    if (closeBtn) closeBtn.addEventListener("click", closeMenu);
    if (overlay) overlay.addEventListener("click", closeMenu);

    document.querySelectorAll("[data-cat-trigger]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const target = document.getElementById(btn.getAttribute("data-cat-target"));
        if (!target) return;
        target.classList.add("open");
        offCanvas.classList.add("pushed");
        btn.setAttribute("aria-expanded", "true");
      });
    });

    document.querySelectorAll("[data-cat-back]").forEach(function (btn) {
      btn.addEventListener("click", closeAllCatDrawers);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        if (document.querySelector(".offcanvas-cat-drawer.open")) {
          closeAllCatDrawers();
        } else if (offCanvas.classList.contains("open")) {
          closeMenu();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newhead"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const hamburger  = document.getElementById("NewheadHamburgerToggle");
    const offCanvas  = document.getElementById("NewheadOffCanvasMenu");
    const closeBtn   = document.getElementById("NewheadCloseMenu");
    const overlay    = document.getElementById("NewheadMenuOverlay");

    if (hamburger && offCanvas) {
      const openMenu = () => {
        offCanvas.classList.add("open");
        overlay.classList.add("active");
        document.body.style.overflow = "hidden";
        hamburger.setAttribute("aria-expanded", "true");
      };

      const closeAllCatDrawers = () => {
        document.querySelectorAll(".newhead-offcanvas-cat-drawer.open").forEach(function (d) {
          d.classList.remove("open");
        });
        offCanvas.classList.remove("pushed");
      };

      const closeMenu = () => {
        closeAllCatDrawers();
        offCanvas.classList.remove("open");
        overlay.classList.remove("active");
        document.body.style.overflow = "";
        hamburger.setAttribute("aria-expanded", "false");
      };

      hamburger.addEventListener("click", openMenu);
      if (closeBtn) closeBtn.addEventListener("click", closeMenu);
      if (overlay) overlay.addEventListener("click", closeMenu);

      document.querySelectorAll("[data-newhead-cat-trigger]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          const target = document.getElementById(btn.getAttribute("data-cat-target"));
          if (!target) return;
          target.classList.add("open");
          offCanvas.classList.add("pushed");
          btn.setAttribute("aria-expanded", "true");
        });
      });

      document.querySelectorAll("[data-newhead-cat-back]").forEach(function (btn) {
        btn.addEventListener("click", closeAllCatDrawers);
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          if (document.querySelector(".newhead-offcanvas-cat-drawer.open")) {
            closeAllCatDrawers();
          } else if (offCanvas.classList.contains("open")) {
            closeMenu();
          }
        }
      });
    }

    /* ---- Desktop mega menu open/close (click to toggle, closes on outside click / Escape) ---- */
    const megaItems = document.querySelectorAll("[data-megamenu-item]");

    const closeAllMega = (except) => {
      megaItems.forEach(function (item) {
        if (item !== except) {
          item.classList.remove("open");
          const t = item.querySelector("[data-megamenu-trigger]");
          if (t) t.setAttribute("aria-expanded", "false");
        }
      });
    };

    megaItems.forEach(function (item) {
      const trigger = item.querySelector("[data-megamenu-trigger]");
      if (!trigger) return;
      trigger.addEventListener("click", function (e) {
        if (e.target.closest("a")) return; // let the heading link navigate normally on direct click
        const isOpen = item.classList.contains("open");
        closeAllMega(item);
        item.classList.toggle("open", !isOpen);
        trigger.setAttribute("aria-expanded", String(!isOpen));
      });
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest("[data-megamenu-item]")) {
        closeAllMega();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAllMega();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
